<template>
  <div class="step1">
    <separate :style="{ height: '2px' }" />
    <detail-line :list="list" />
    <separate :style="{ height: '10px' }" />
    <operate-step />
    <separate :style="{ height: '10px' }" />
    <warn />
    <separate :style="{ height: '10px' }" />
  </div>
</template>

<script lang="ts" setup>
import Separate from '@core/components/separate.vue'
import DetailLine from '@/views/score/component/orderDetail/detailLine.vue'
import OperateStep from '@/views/score/component/scoreRecharge/operateStep.vue'
import Warn from '@/views/score/component/scoreRecharge/warn.vue'
import lang from '@/langs'
import { useUserStore } from '@core/stores/user'
const { nativeInfo } = useUserStore()
const code = nativeInfo.stationCode
const list = [
  { name: lang('银行名称'), value: 'Banco de Oro Unibank, Inc' },
  { name: lang('银行账户'), value: '007410162330' },
  { name: lang('收款人'), value: 'PH GLOBAL JET EXPRESS INC' },
  {
    name: lang('汇款备注'),
    value: code,
    valueColor: 'rgba(255, 0, 0, 1)'
  }
]
</script>

<style scoped lang="less">
.step1 {
}
</style>
